import { createAsyncThunk } from '@reduxjs/toolkit';

export const ThunkRemoveTeamsBotImage = createAsyncThunk(
  'microsoft/removeTeamsBotImage',
  () => {},
);

export default {};
